import { PaymentMethodEnum, ProviderEnum } from '@/types/common';
import type { ICheckoutContext } from '@/types/context';
import type { NuveiPaymentResponse, StripePaymentResponse } from '@/types/payment';
import { handleGenericStripePayment } from './genericStirpePaymentHandle';
import { handleNuveiGenericPayment } from './nuveiGenericPaymentHandle';

export const handlePixPayment = async (
  checkout: ICheckoutContext,
  sendPaymentToServer: <TResponse>(params: unknown) => Promise<TResponse>,
  params?: Record<string, string>
): Promise<StripePaymentResponse | NuveiPaymentResponse> => {
  const pixSettings = checkout.paymentMethodsSettings.find((pm) => pm.paymentMethodName === PaymentMethodEnum.PIX);

  if (!pixSettings) {
    throw new Error('Pix settings not found');
  }

  switch (pixSettings.provider) {
    case ProviderEnum.STRIPE:
      return (await handleGenericStripePayment(checkout, sendPaymentToServer, params ?? {})) as StripePaymentResponse;
    case ProviderEnum.NUVEI:
      return (await handleNuveiGenericPayment(checkout, sendPaymentToServer, params ?? {})) as NuveiPaymentResponse;
    default:
      throw new Error(`Unsupported provider for Pix: ${pixSettings.provider}`);
  }
};
